<template>
    <div class="main">
        <div class="bacg left"></div>
        <div class="loginBox">
            <p class="title">服务平台</p>
            <p class="minTitle">登录</p>
            <el-form class="form" :rules="rules" ref="loginForm" :model="user">
                <el-form-item prop="username">
                    <el-input prefix-icon="el-icon-user" placeholder="请输入OA系统账号" v-model="user.username"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input show-password prefix-icon="el-icon-warning-outline" placeholder="请输入OA系统密码"
                        v-model="user.password">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="warning" @click="login">登录</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="bacg right"></div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            user: {
                username: '',
                password: '',
            },
            rules: {
                username: [{ required: true, message: '请输入OA系统账号', trigger: 'blur' }],
                password: [{ required: true, message: '请输入OA系统密码', trigger: 'blur' }],
            },
        }
    },
    methods: {
        login() {
            this.$refs.loginForm.validate(async (valid) => {
                if (!valid) return;
                // 修复：补充完整 loading 配置
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });

                try {
                    // 1. 登录请求
                    const { data: res } = await this.$http.post(
                        'api/auth/external/login/',
                        JSON.stringify({
                            username: this.user.username,
                            password: this.user.password,
                        }),
                        {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        }
                    );

                    if (res.code !== 200) {
                        this.$message.error(res.msg || '登录失败');
                        loading.close();
                        return;
                    }

                    // 2. 存储 token
                    const token = 'Bearer ' + res.data.access;
                    localStorage.setItem('adminToken', token);
                    localStorage.setItem('tokenStartTime', Math.round(Date.now() / 1000).toString());

                    // 3. 获取用户信息
                    const { data: userRes } = await this.$http.get(
                        'api/auth/external/owner/',
                        { headers: { Authorization: token } }
                    );

                    if (!userRes.data) {
                        throw new Error('用户信息为空');
                    }

                    // 4. 存储用户信息
                    localStorage.setItem('adminName', userRes.data.showname || '');
                    localStorage.setItem('userId', userRes.data.id || '');
                    localStorage.setItem('isSuperuser', userRes.data.is_superuser ? 'true' : 'false');
                    localStorage.setItem('isStaff', userRes.data.is_staff ? 'true' : 'false');
                    localStorage.setItem('isHrAudit', userRes.data.is_hr_audit ? 'true' : 'false');
                    localStorage.setItem('isFinAudit', userRes.data.is_fin_audit ? 'true' : 'false');

                    // 5. 登录成功跳转
                    this.$message.success('登录成功');
                    this.$router.push('/home');

                } catch (err) {
                    const errorMsg = err.response?.data?.message || err.message || '登录失败';
                    this.$message.error(errorMsg);
                    console.error('登录流程错误:', err);
                } finally {
                    loading.close(); // 无论成功失败，都关闭加载
                }
            });
        },
    },
}
</script>

<style lang="less" scoped>
.main {
    background-color: #fff;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    align-content: center;
    justify-content: center;

    .bacg {
        width: 30%;
        background-color: #fff;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 50% 50%;
    }

    .left {
        background-image: url('../../images/u2669.svg');
    }

    .right {
        background-image: url('../../images/u2670.svg');
    }

    .loginBox {
        width: 440px;
        height: 510px;
        border-radius: 5px;
        background-color: #006eff;
        position: relative;
        top: calc(50% - 285px);
    }

    .title {
        font-size: 40px;
        margin: 0;
        color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 40px;
    }

    .minTitle {
        font-size: 17px;
        text-align: center;
        color: #fff;
        margin-top: 25px;
        letter-spacing: 2px;
    }

    .form {
        margin: 0 auto;
        margin-top: 50px;
        width: 80%;

        .el-button {
            margin-top: 50px;
            width: 100%;
        }
    }
}
</style>